













































import { defineComponent, ref, computed } from "@vue/composition-api";
import useCoreHistory from "@/store/useCoreHistory";
import moment from 'moment-timezone';
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    setup(_, context) {
        const { getUserSettings } = useUserSettings();
        const userSettings = ref<UserSettingsViewModel>();
        getUserSettings().then((value: UserSettingsViewModel) => {
            userSettings.value = value;
        });

        const { logItems } = useCoreHistory();

        const timezone = computed(() => userSettings.value?.timezone || "UTC");

        const formatModifiedDate = (modifiedDate: string) => {
            return moment.utc(modifiedDate).tz(timezone.value).format("MMM DD, YYYY HH:mm:ss");
        };

        return {
            logItems,
            userSettings,
            timezone,
            formatModifiedDate
        };
    }
});
